import { Fragment, useLayoutEffect, useMemo } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { nativeApplicationVersion, nativeBuildVersion } from 'expo-application';

import { DefaultLayout, Divider, HeaderBackButton, Text, spacing, PletlyLogo } from '@pletly/ui';
import { NewVersionInfo, PrivacyPolicyLink, TermsOfUseLink } from '../../components';
import { withTranslation } from '../../locales/hoc';

const About = () => {
	const { goBack, setOptions } = useNavigation();
	const { t } = useTranslation();

	useLayoutEffect(() => {
		setOptions({
			headerShown: true,
			headerLeft: () => <HeaderBackButton onPress={goBack} />,
			headerTitle: t('about.title'),
		});
	}, [setOptions, goBack, t]);

	const sections = useMemo(
		() =>
			Platform.OS !== 'web'
				? [
						{
							title: t('about.version'),
							value: nativeApplicationVersion,
							secondRow: <NewVersionInfo />,
						},
						{
							title: t('about.build-number'),
							value: nativeBuildVersion,
						},
					]
				: [],
		[t],
	);

	return (
		<DefaultLayout view style={styles.root}>
			<PletlyLogo style={logoStyle} />
			{sections.map((section, index) => (
				<Fragment key={index}>
					<View style={styles.section}>
						<Text status="primary" category="h5">
							{section.title}
						</Text>
						<Text status="basic" category="s1">
							{section.value || ''}
						</Text>
					</View>
					{section.secondRow}
					<Divider />
				</Fragment>
			))}
			<View style={styles.section}>
				<PrivacyPolicyLink withArrow />
			</View>
			{['ios', 'macos'].includes(Platform.OS) ? (
				<>
					<Divider />
					<View style={styles.section}>
						<TermsOfUseLink withArrow />
					</View>
				</>
			) : null}
		</DefaultLayout>
	);
};

const logoStyle = {
	margin: spacing(4),
	alignSelf: 'center',
};
const styles = StyleSheet.create({
	root: {
		display: 'flex',
	},
	section: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
});

export const AboutPage = withTranslation(About);
